import { createApiRef } from '@backstage/core-plugin-api';
import { RestClientApi } from '@runway/devkit-common';

export const restClientRef = createApiRef<RestClientApi>({
  id: 'runway.rest.client',
});
